"use client";

import { useEffect, useState } from 'react';
import Image from 'next/image';
import APP_CONFIG from '@/config/app.config';

/**
 * GlobalLoader: Full-screen overlay to prevent FOUC during auth initialization.
 * Shows a frosted glass background with a spinning wheel and bouncing dots.
 */
export const GlobalLoader = () => {
  const [booted, setBooted] = useState(false);

  useEffect(() => {
    const handle = window.setTimeout(() => setBooted(true), 500);
    return () => window.clearTimeout(handle);
  }, []);

  const loading = !booted;

  // Show a short site-boot loader on first paint, and keep it visible while
  // protected-route authentication is still initializing.
  if (!loading) return null;

  // Asset path for the spinning wheel
  const logoSrc = '/newloader.png';

  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-background/50 backdrop-blur-md animate-in fade-in duration-200 pointer-events-auto">
      <div className="relative flex flex-col items-center gap-6">
        
        {/* Logo Wheel Container: Spins continuously */}
        <div className="relative w-24 h-24 animate-spin duration-1000">
          <Image
            src={logoSrc}
            alt="Loading..."
            fill
            className="object-contain"
            sizes="96px"
          />
        </div>

        {/* Text and Indicator Container */}
        <div className="flex flex-col items-center gap-3">
          {/* Dynamic Loading Text */}
          <div className="text-xl font-semibold text-foreground animate-pulse">
             {APP_CONFIG.site.name} is on the way...
          </div>
          
          {/* Bouncing Dots Indicator: Visual feedback of activity */}
          <div className="flex gap-2 mt-2">
            <div className="w-3 h-3 bg-primary rounded-full animate-bounce [animation-delay:-0.3s]"></div>
            <div className="w-3 h-3 bg-primary rounded-full animate-bounce [animation-delay:-0.15s]"></div>
            <div className="w-3 h-3 bg-primary rounded-full animate-bounce"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
